import { createRootRouteWithContext, Outlet, redirect } from '@tanstack/react-router'
import type { Auth0ContextInterface } from '@auth0/auth0-react'


const Outlet_ = () => {
    const { auth: { isAuthenticated } } = Route.useRouteContext();

    if (!isAuthenticated && !['/login', '/callback'].includes(location.pathname)) {
        return;
    }

    return <Outlet/>
}


export const Route = createRootRouteWithContext<{ auth: Auth0ContextInterface }>()({
    beforeLoad: ({ context: { auth }, location }) => {
        if (!['/login', '/callback'].includes(location.pathname) && !auth.isAuthenticated && !auth.isLoading) {
            throw redirect({
                to: '/login',
                search: {
                    returnTo: location.href.replace(window.location.origin, ''),
                    env: import.meta.env.VITE_ENV || import.meta.env.VITE_DEPLOY_ENV,
                },
            });
        }
    },
    component: () => <Outlet_/>,
})
